// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"_8SC2W","rc-tabs-tab-active":"y4Tzw","input-suffix":"e32Rc","nav-item":"huxw-","select-container":"_15LL5","select":"dzb-q"};